import type { APIBodyParams, APIQueryParams, APIResource } from '~~/entities/api'
import type { Slide } from '~~/entities/slide'

export function useDeckSlides(deckId: string | number) {
  const {
    createItem: createSlide,
    listItems: listSlides,
    getItem: getSlide,
    updateItem: updateSlide,
    deleteItem: deleteSlide,
    cloneItem: cloneSlide,
  } = useAPIClient<Slide, APIQueryParams, APIBodyParams>(`/v2/decks/${deckId}/slides`)

  async function bulkUpdateSlides(body: APIBodyParams[]): Promise<Slide[]> {
    return $fetch<Slide[]>(`/v2/decks/${deckId}/slides`, {
      ...useFetchSharedOptions(),
      method: 'PATCH',
      body,
    })
  }

  async function bulkDeleteSlides(body: APIBodyParams[]): Promise<Slide[]> {
    return $fetch<Slide[]>(`/v2/decks/${deckId}/slides`, {
      ...useFetchSharedOptions(),
      method: 'DELETE',
      body,
    })
  }

  async function cloneSlidesToDeck(body: APIBodyParams[]): Promise<APIResource[]> {
    return $fetch<APIResource[]>(`/v2/slides/clone`, {
      ...useFetchSharedOptions(),
      method: 'POST',
      body,
    })
  }

  return {
    createSlide,
    listSlides,
    getSlide,
    updateSlide,
    deleteSlide,
    cloneSlide,
    cloneSlidesToDeck,
    bulkUpdateSlides,
    bulkDeleteSlides,
  }
}
